import { IModuleProps } from '../core/utils/modules';

import routes from './routes';

export default {
    name: 'login',
    routes,
} as IModuleProps;
